"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findInMenuItems = exports.SettingsSectionKeys = void 0;
var account_1 = __importDefault(require("./account"));
var ChanceEmail_1 = __importDefault(require("./account/ChanceEmail"));
var ChangePassword_1 = __importDefault(require("./account/ChangePassword"));
var DeactivateAccount_1 = __importDefault(require("./account/DeactivateAccount"));
var preferences_1 = __importDefault(require("./preferences"));
var profile_1 = __importDefault(require("./profile"));
exports.SettingsSectionKeys = {
    PROFILE: 'settings_profile',
    PREFERENCES: 'settings_preferences',
    ACCOUNT_SECURITY: 'settings_account_security',
    CHANGE_PASSWORD: 'settings_change_password',
    CHANGE_EMAIL: 'settings_change_email',
    CHANGE_SECURITY_QUESTIONS: 'settings_change_security_questions',
    DEACTIVATE_ACCOUNT: 'settings_deactivate_account'
};
var menuItems = [
    {
        key: 'settings_profile',
        title: 'Profile',
        component: profile_1.default
    },
    {
        key: 'settings_preferences',
        title: 'Communication Preferences',
        component: preferences_1.default
    },
    {
        key: 'settings_account_security',
        title: 'Account & Security',
        component: account_1.default,
        subMenu: [
            {
                key: 'settings_change_password',
                title: 'Change Password',
                component: ChangePassword_1.default
            },
            {
                key: 'settings_change_email',
                title: 'Change Email',
                component: ChanceEmail_1.default
            },
            {
                key: 'settings_deactivate_account',
                title: 'Deactivate Account',
                component: DeactivateAccount_1.default
            }
        ]
    }
];
var findInMenuItems = function (key) {
    var selectedItem = menuItems.find(function (item) { return item.key === key; });
    if (selectedItem) {
        return selectedItem;
    }
    var hasSubItem = menuItems.find(function (item) {
        if (!item.subMenu) {
            return false;
        }
        selectedItem = item.subMenu.find(function (subMenuItem) { return subMenuItem.key === key; });
        return !!selectedItem;
    });
    if (hasSubItem) {
        return selectedItem;
    }
};
exports.findInMenuItems = findInMenuItems;
exports.default = menuItems;
//# sourceMappingURL=menu.js.map